import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { FacebookService, InitParams, UIParams, UIResponse } from 'ngx-facebook';
import { address } from '../../../../environments/environment';


@Injectable()

export class apiService {
  private ROOT_URL = address.API_SERVER_ADDRESS;
  
  private accessToken: any;
  private userID: any;
  constructor(private http: HttpClient, private fb: FacebookService) {

    let initParams: InitParams = {
      appId: '2053390398314195',
      xfbml: true,
      version: 'v2.8'
    };

    fb.init(initParams).then(res => {
      //   console.log('Respnse:', res);
    }).catch(error => {
      //   console.log('Error:', error);
    });
  }

  posOnFacebook(data) {
    // console.log('Geting Access Token');
    this.fb.login()
      .then(response => {
        // console.log('Logged in', response);
        this.accessToken = response.authResponse.accessToken;
        this.userID = response.authResponse.userID;
        // var body = 'Reading JS SDK documentation';
        // this.fb.api('me/feed', 'post', function(response){
        //     if(!response || response.error){
        //         console.log('Error occurred');
        //     }
        //     else{
        //         console.log('Post ID:', response.id);
        //     }
        // })

      })
      .catch(e => console.error('Error logging in'));


    // console.log('Sending to Server');
    // let url = `${this.ROOT_URL}/api/facebook`;
    // let body = new HttpParams();
    // body = body.set('accessToken', this.accessToken);
    // body = body.set('userID', this.userID);
    // const myheader = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    // this.http.post(url, body, {headers:myheader}).subscribe();
    //return this.http.post(url, {'accessToken' : this.accessToken}).toPromise();
    //this.http.post(url, {'accessToken':this.accessToken});
  }

  async sendEmail(emailData, customerquery) {
    var headers = new HttpHeaders();
    let body = new HttpParams();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    body = body.set('email', emailData.email);
    body = body.set('type', customerquery);
    this.http.post(this.ROOT_URL + '/sendEmail', body, { headers: headers }).subscribe((result: any) => {
      // console.log('resut', result);
    })
  }


}

